"use strict";
// for more information about this file's intention and inception, see:
// https://bitbucket.org/kyruus/kyruus-components/pull-requests/690/keng-18607-forms-v2-defaults-and#comment-195651247
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachMultiPartConfig = exports.attachBaseConfig = void 0;
// Base configs
const checkbox_input_1 = require("./inputs/checkbox-input");
const date_input_1 = require("./inputs/date-input");
const dob_input_1 = require("./inputs/dob-input");
const email_input_1 = require("./inputs/email-input");
const radio_input_1 = require("./inputs/radio-input");
const select_input_1 = require("./inputs/select-input");
const simple_select_input_1 = require("./inputs/simple-select-input");
const ssn_input_1 = require("./inputs/ssn-input");
const text_input_1 = require("./inputs/text-input");
const time_input_1 = require("./inputs/time-input/");
const textarea_input_1 = require("./inputs/textarea-input");
const typeahead_input_1 = require("./inputs/typeahead-input");
// MultiPart configs
const name_input_row_1 = require("./rows/name-input-row");
const address_input_row_1 = require("./rows/address-input-row");
const phone_input_1 = require("./inputs/phone-input");
const label_1 = __importDefault(require("./label"));
const baseDefaults = {
    checkbox: checkbox_input_1.defaultConfig,
    date: date_input_1.defaultConfig,
    dob: dob_input_1.defaultConfig,
    email: email_input_1.defaultConfig,
    label: label_1.default,
    phone: phone_input_1.defaultConfig,
    radio: radio_input_1.defaultConfig,
    select: select_input_1.defaultConfig,
    simpleSelect: simple_select_input_1.defaultConfig,
    ssn: ssn_input_1.defaultConfig,
    string: text_input_1.defaultConfig,
    time: time_input_1.defaultConfig,
    textarea: textarea_input_1.defaultConfig,
    typeahead: typeahead_input_1.defaultConfig
};
const multiPartDefaults = { name: name_input_row_1.defaultConfig, address: address_input_row_1.defaultConfig, phone: phone_input_1.defaultConfig };
const titleCase = (str) => str[0].toUpperCase() + str.slice(1);
const globalDefaultsFor = (field = 'Field') => ({
    isDefaultEmpty: false,
    isRequiredMsg: `${titleCase(field)} is required`,
    invalidMsg: `${titleCase(field)} is not valid`
});
const attachBaseConfig = (configNode) => {
    const { type } = configNode;
    const typeConfig = baseDefaults[type] || {};
    return Object.assign(Object.assign(Object.assign({}, globalDefaultsFor(type)), typeConfig), configNode);
};
exports.attachBaseConfig = attachBaseConfig;
const attachMultiPartConfig = (configNode) => {
    const { type } = configNode;
    const typeConfig = multiPartDefaults[type] || {};
    return Object.assign(Object.assign({}, configNode), { subFields: Object.entries(configNode.subFields).reduce((config, [subFieldName, value]) => {
            const defaultTypeConfig = typeConfig[subFieldName];
            return Object.assign(Object.assign({}, config), { [subFieldName]: Object.assign(Object.assign(Object.assign({}, globalDefaultsFor(subFieldName)), defaultTypeConfig), value) });
        }, {}) });
};
exports.attachMultiPartConfig = attachMultiPartConfig;
//# sourceMappingURL=default-configs.js.map